import { useState } from "react";
import { Locale } from "@linkfluence/models/locale";
import { useProject } from "@radarly/core/project/context";
import { tr } from "@radarly/i18n";
import { DiscoveryRow } from "@radarly/models/discovery";

const fetchData = async (meta: DiscoveryRow["meta"], projectId: number) => {
  const AICHA_PATH = `/3.0/projects/${String(projectId)}/aicha/explain`;
  const PATH_PREFIX = location.hostname === "localhost" ? "/radarly" : "";

  try {
    const res = await fetch(PATH_PREFIX + AICHA_PATH, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(meta),
    });
    if (res.ok) {
      const { data } = await res.json();
      return { data };
    } else {
      return { error: true };
    }
  } catch (e) {
    console.error(e);
    return { error: true };
  }
};

const useData = (locale: Locale) => {
  const project = useProject();
  const [_data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onFetch = async (meta: DiscoveryRow["meta"]) => {
    setIsLoading(true);
    const { error, data } = await fetchData(meta, project.id);

    if (error) {
      setData(tr(locale, "DISCOVERY::AICHA::DATA_ERROR_PLACEHOLDER"));
    } else {
      setData(data);
    }
    setIsLoading(false);
    return data;
  };
  return { data: _data, isLoading, onFetch };
};

export const useAicha = (meta: DiscoveryRow["meta"], locale: Locale) => {
  const [open, setOpen] = useState(false);
  const { data, onFetch } = useData(locale);
  const isExplanationOpen = open;

  const onOpen = async (open: boolean) => {
    if (open) {
      !data && onFetch(meta);
    }
    setOpen(open);
  };
  return { isExplanationOpen, onOpen, explanation: data };
};

export { CallAicha } from "./button";
export { TellMeAicha } from "./explanation";
